<template>
  <thead>
    <tr>
      <th></th>
      <th class="text-center">+ 3</th>
      <th class="text-center">+ 2</th>
      <th class="text-center">+ 1</th>
      <th class="text-center">0</th>
      <th class="text-center">+ 1</th>
      <th class="text-center">+ 2</th>
      <th class="text-center">+ 3</th>
      <th></th>
    </tr>
  </thead>
</template>

<script>
// @ is an alias to /src
export default {
  name: "TovHeader",
};
</script>
